module.exports = __webpack_public_path__ + "media/images/invited-b7bf5dd5.svg";